import { buildClientLink } from 'Views/Page/Content/Templates';
import { FDAvatar, FDIcon } from '@facet-wealth/design';
import React from 'react';
import { useProfileImageContext } from 'Components/ClientApp/ProfileImageContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useNewClientContext } from 'Context/NewClientContext';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import { NavButton } from '../NavButton';

export const ProfileNavButton = ({ hideAvatar }) => {
  const { clientResource } = useNewClientContext();
  const profileImage = useProfileImageContext();
  let avatar = null;
  if (!hideAvatar) {
    if (profileImage) {
      avatar = (
        <FDAvatar
          alt="Your avatar"
          src={profileImage}
          size="sm"
        />
      );
    } else avatar = <FDIcon icon="person" color="primary" size="md" />;
  }

  if (!clientResource) {
    return null;
  }

  return clientResource.withRelationship(
    fr.relationships.householdMembershipPage.name,
    (rel) => (
      <NavButton
        value="profile"
        to={buildClientLink(rel.link('related'))}
        label={(
            <>
              {avatar && <Box paddingRight={1} test="account-avatar-button" display="flex">{avatar}</Box>}
              Profile
            </>
        )}
      />
    ),
    () => null,
  );
};

ProfileNavButton.defaultProps = {
  hideAvatar: false,
};
ProfileNavButton.propTypes = {
  hideAvatar: PropTypes.bool,
};
